import { debounce } from "lodash";
import { useState } from "react";
import { theme } from "../../theme/theme";
import { V3Button } from "../Button";
import { V3IconMagnifier } from "../Icons";
import { V3CheckBox } from "../OptionInput";
import { RightAlignPanel } from "../ReusableStyledComponents/RightAlignPanel";
import { V3BodyGrey35 } from "../ReusableStyledComponents/V3BodyGrey35";
import { V3TextInput } from "../TextInput/V3TextInput";
import { V3ModalBase } from "../V3ModalBase";
import { VerticalSpacing } from "../VerticalSpacing";
import { SelectItemsListWrapper, SelectItemsNoSearchResults } from "./SelectItemsModal.styles";

interface SelectItemsModalProps {
    items: { label: string; value: string }[];
    selectedItems: string[];
    onModalSubmitClose: (items: string[]) => void;
    isOpen: boolean;
    setModalOpen: (open: boolean) => void;
    title?: string;
    btnLabel?: string;
}

export const SelectItemsModal = ({
    items,
    selectedItems,
    title = "Filter sources",
    setModalOpen,
    isOpen,
    onModalSubmitClose,
    btnLabel = "Apply Filters"
}: SelectItemsModalProps) => {
    const [modalSearchTerm, setModalSearchTerm] = useState("");
    const debouncedSetSearch = debounce(setModalSearchTerm, 250);
    const [selection, setSelection] = useState([...selectedItems]);

    const filteredItems = items.filter((item) => item.label?.toLowerCase().includes(modalSearchTerm.toLowerCase()));

    return (
        <V3ModalBase
            isOpen={isOpen}
            onClose={() => setModalOpen(false)}
            title={title}
            bottomPanel={
                <RightAlignPanel>
                    <V3Button
                        text={btnLabel}
                        onClick={() => {
                            onModalSubmitClose(selection);
                            setModalOpen(false);
                        }}
                        autoWidth
                    />
                </RightAlignPanel>
            }
        >
            {items.length > 10 && (
                <VerticalSpacing bottom={theme.v3.spacings.spacing6}>
                    <V3TextInput
                        placeholder="Search publishers..."
                        isRounded
                        onChange={(e) => debouncedSetSearch(e.target.value)}
                        icon={<V3IconMagnifier />}
                    />
                </VerticalSpacing>
            )}
            <SelectItemsListWrapper>
                {filteredItems.map((item, index) => (
                    <VerticalSpacing bottom={index !== items.length - 1 ? 18 : 0} key={item.value}>
                        <V3CheckBox
                            label={item.label || ""}
                            name={item.value}
                            id={`select-item-modal-${item.value}`}
                            checked={selection.includes(item.value)}
                            onChange={(e) => {
                                const { checked, name } = e.target;

                                if (checked) {
                                    setSelection([...selection, name]);
                                } else {
                                    setSelection(selection.filter((v) => v !== name));
                                }
                            }}
                        />
                    </VerticalSpacing>
                ))}
                {!filteredItems.length && modalSearchTerm !== "" && (
                    <SelectItemsNoSearchResults>
                        <VerticalSpacing top={54}>
                            <V3BodyGrey35>No search results</V3BodyGrey35>
                        </VerticalSpacing>
                    </SelectItemsNoSearchResults>
                )}
            </SelectItemsListWrapper>
        </V3ModalBase>
    );
};
